export type FontToken = keyof typeof fontTokens;

export const fontTokens = {
  "$base-font":
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", sans-serif',
  "$heading-font":
    '"Kivra Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", sans-serif',
};
